import React, {Component} from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import {CircularProgress, List, Pagination} from "@mui/material";
import {CenterLoading} from "../functions";

export default class GenreView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: [],
            error: false,
            newGenreListPage: 1,
            newGenreList: [],
            isGenre: false,
        };
    }

    componentDidMount() {
        // Safe to call setState here
        this.openGenreList(this.props.value);
    }

    animePageChanged = (event, value) => {
        this.setState({ newGenreListPage: value });
    }

    checkTheme = () => localStorage.getItem("theme")?.includes("true") ?? true;

    checkLogged = () => localStorage.getItem("logged") !== null;

    accountData = () => this.checkLogged() ? JSON.parse(localStorage.getItem("loggedData")) : null;

    openGenreList = (item) => {
        // Safe to call setState here
        this.setState({ isGenre: false, loading: true });

        let url = `https://app.sanime.net/function/h10.php?page=genre&id=${item.data}`;
        if (this.checkLogged()) {
            url += `&email=${this.accountData().email}`;
        }

        fetch(url)
            .then((res) => res.text())
            .then((value) => {
                const list = JSON.parse(value);
                this.setState({
                    newGenre: true,
                    newGenreTitle: item.name,
                    loading: false,
                    newGenreList: list.array_chunk(50),
                    newGenreListPage: 1
                });
            })
            .catch(() => {
                window.main.goLink("/");
            });
    }

    render() {
        const { loading, newGenreList, newGenreListPage } = this.state;

        if (loading) return <CenterLoading />;

        if (!newGenreList || newGenreList.length === 0) {
            return (
                <Box height="100%">
                    <Box height="100%" sx={{ mb: 1 }}>
                        <List>
                            <ListItem sx={{ p: 0, placeContent: "center" }}>
                                <Typography sx={{ fontFamily: "'Changa'" }}>
                                    لاتوجد أنميات في هذا التصنيف
                                </Typography>
                            </ListItem>
                        </List>
                    </Box>
                </Box>
            );
        }

        return (
            <Box height="100%">
                <Box sx={{ mt: 1 }}>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid item xs={12}>
                            <Grid container justifyContent="center" spacing={1.4}>
                                {newGenreList[newGenreListPage - 1].map((r) => (
                                    <Grid key={r.id} item>
                                        <Card sx={{ width: window.main.if360() ? 105 : 120 }}>
                                            <CardActionArea
                                                disableRipple
                                                disableTouchRipple
                                                onClick={() => window.main.goLink(`/info?id=${r.id}`)}
                                            >
                                                <CardMedia component="img" height="185" image={r.image} alt={r.name} />
                                                <Divider sx={{ height: 1.2 }} color="#00b2ff" />
                                                <Stack sx={{ px: 0.5, pb: 0.5, pt: 0.125 }} spacing={0}>
                                                    <Typography sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", fontSize: 14 }}>
                                                        {r.name}
                                                    </Typography>
                                                    <Typography sx={{ textAlign: "right", fontSize: 14 }}>{r.status}</Typography>
                                                </Stack>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Pagination
                        className="centerPage"
                        sx={{ m: 0.5 }}
                        siblingCount={0}
                        size="large"
                        color="primary"
                        page={newGenreListPage}
                        onChange={this.animePageChanged}
                        count={newGenreList.length}
                        variant="outlined"
                        shape="rounded"
                    />
                </Box>
                <div style={{height: 120}}/>
            </Box>
        );
    }
}
